export default "__VITE_ASSET__BdrnqTzu__"